import axios from 'axios';
//de baseURL van de api, die door NGINX wordt doorgezet naar http://localhost:3001/api/

//withCredentials: true nodig om cookies te kunnen versturen

const httpClient = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_API
});

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 404) {
      /*store.setModal({
        title: 'Bestaat niet',
        text: `Deze pagina bestaat niet.`,
        type: 'notification'
      });*/
      console.log('ERROR 404');
    }
    if (error.response && error.response.status === 403) {
      console.log('ERROR 403');
      /*store.setModal({
        title: 'Je hebt geen toegang hiertoe',
        text: `Je hebt geen rechten voor deze actie`,
        type: 'notification'
      });*/
    }
    // er is een fout met de request die niet aan een token ligt, kortom er is serverside iets mis.
    return;
  }
);

export default httpClient;
